<template>
  <div class="voucher-summary">
    <div class="summary-row">
      <div class="label">ยอดรวม</div>
      <div class="amount">{{ totalPrice | currency2 }}</div>
    </div>

    <div v-if="discount > 0" class="summary-row">
      <div class="label">ส่วนลด</div>
      <div class="amount">- {{ discount | currency2 }}</div>
    </div>

    <div v-if="type === TRADEIN_TYPE.TRADEIN" class="summary-row">
      <div class="label">
        ส่วนลด Trade-in
        <span
          v-if="tradeInVoucherCount > 0"
          class="badge"
          :style="badgeStyle"
        >
          {{ tradeInVoucherCount }} โค้ด
        </span>
      </div>
      <div class="amount">- {{ tradeInDiscount | currency2 }}</div>
    </div>

    <div v-if="type === TRADEIN_TYPE.BNTL" class="summary-row">
      <div class="label">
        ใช้โค้ดลดในครั้งถัดไป
        <span
          v-if="tradeInVoucherCount > 0"
          class="badge"
          :style="badgeStyle"
        >
          {{ tradeInVoucherCount }} โค้ด
        </span>
      </div>
      <div class="amount">{{ tradeInDiscount | currency2 }}</div>
    </div>

    <hr class="divider" />

    <div class="summary-row">
      <div class="label-bold">ยอดสุทธิ</div>
      <div class="amount-bold">{{ finalPrice | currency2 }}</div>
    </div>
  </div>
</template>

<script>
import { TRADEIN_TYPE } from '@/config/order'
import colorBnn from '@/config/color'

export default {
  name: 'BaseTradeInVoucherSummary',

  props: {
    type: {
      type: String,
      default: '',
    },
    totalPrice: {
      type: Number,
      required: true,
    },
    discount: {
      type: Number,
      default: 0,
    },
    tradeInDiscount: {
      type: Number,
      default: 0,
    },
    tradeInVoucherCount: {
      type: Number,
      default: 0,
    },
    finalPrice: {
      type: Number,
      required: true,
    },
  },

  data() {
    return {
      colorBnn,
      TRADEIN_TYPE,
    }
  },

  computed: {
    badgeStyle() {
      return {
        color: colorBnn['color-bnn'],
        backgroundColor: colorBnn['color-bnn-light'],
      }
    },
  },
}
</script>

<style lang="stylus" scoped>
.voucher-summary {
    display: flex;
    flex-direction: column;
}

.summary-row {
    display: flex;
    justify-content: space-between;
    align-items: baseline;
    gap: 8px;
    margin-bottom: 8px;
	padding-inline: 16px;

    .label,
    .amount {
        font-size: 14px;
        font-weight: 500;
    }

    .amount {
        text-align: right;
    }

    .label-bold,
    .amount-bold {
        font-family: 'SF Pro Display';
        font-size: 20px;
        font-weight: 600;
    }

    .amount-bold {
        text-align: right;
    }
}

.badge {
    display: inline-flex;
    align-items: center;
    margin-left: 4px;
    padding: 2px 6px;
    border-radius: 24px;

    font-size: 10px;
    font-weight: bold;
	line-height: 16px;
}

.divider {
    border: none;
    border-top: 1px solid rgba(#000000, 0.15);
    margin: 8px 0;
}
</style>
